module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page admin-dashboard"
  }, [_c('h1', {
    staticClass: "page-header color-1-100"
  }, [_vm._v("Welcome to your dashboard!")]), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "anchor-item color-1-20 companies",
    class: [{
      'active  color-1-100': _vm.activeSection === 'dashboardCompanies'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('dashboardCompanies')
      }
    }
  }, [_vm._v("Companies and Users")])]), _vm._v(" "), _c('div', {
    staticClass: "anchor-item color-1-20 searches",
    class: [{
      'active  color-1-100': _vm.activeSection === 'dashboardSearches'
    }]
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('dashboardSearches')
      }
    }
  }, [_vm._v("Popular Searches")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [_c('div', {
    ref: "dashboardCompanies",
    staticClass: "content-section company-section no-margin-top",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n          Companies and users\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "companies-section"
  }, [_c('div', {
    staticClass: "section-head has-icon"
  }, [_c('span', {
    staticClass: "section-title company-icon"
  }, [_vm._v("\n                Companies\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "section-actions"
  }, [_c('router-link', {
    staticClass: "action-all",
    attrs: {
      "to": {
        name: 'companies'
      }
    }
  }, [_vm._v("See all")]), _vm._v(" "), _c('router-link', {
    staticClass: "action-add",
    attrs: {
      "to": {
        name: 'add-company'
      }
    }
  }, [_vm._v("Add new")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.companies), function(count, index) {
    return _c('router-link', {
      key: index,
      staticClass: "section-item",
      attrs: {
        "to": {
          name: 'companies',
          query: {
            status: index
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("\n                  " + _vm._s(_vm.getCompanyStatus(index)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-meta"
    }, [_c('span', {
      staticClass: "item-count"
    }, [_vm._v(_vm._s(count))]), _vm._v(" "), _c('span', {
      staticClass: "item-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "users-section"
  }, [_c('div', {
    staticClass: "section-head has-icon"
  }, [_c('span', {
    staticClass: "section-title user-icon"
  }, [_vm._v("\n                Users\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "section-actions"
  }, [_c('router-link', {
    staticClass: "action-all",
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_vm._v("See all")]), _vm._v(" "), _c('router-link', {
    staticClass: "action-add",
    attrs: {
      "to": {
        name: 'add-user'
      }
    }
  }, [_vm._v("Add new")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.users), function(user) {
    return _c('router-link', {
      key: user.slug,
      staticClass: "section-item",
      attrs: {
        "to": {
          name: 'users',
          query: {
            role: user.slug
          }
        }
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("\n                  " + _vm._s(_vm.getUserRoleName(user.slug)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-meta"
    }, [_c('span', {
      staticClass: "item-count"
    }, [_vm._v(_vm._s(user.c))]), _vm._v(" "), _c('span', {
      staticClass: "item-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    ref: "dashboardSearches",
    staticClass: "content-section searches-section",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("\n          Popular searches in the past 30 days\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-section"
  }, [_c('div', {
    staticClass: "companies-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.topZeroSearch), function(item) {
    return _c('div', {
      staticClass: "section-item"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("\n                  " + _vm._s(item.search) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-meta"
    }, [_c('span', {
      staticClass: "item-count"
    }, [_vm._v(_vm._s(item.count))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "users-section"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, _vm._l((_vm.topSearch), function(item) {
    return _c('div', {
      staticClass: "section-item"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v("\n                  " + _vm._s(item.search) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "item-meta"
    }, [_c('span', {
      staticClass: "item-count"
    }, [_vm._v(_vm._s(item.count))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("\n                Searches with 0 results\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('span', {
    staticClass: "section-title"
  }, [_vm._v("\n                Searches with results\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73d0d9b5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Admin/AdminDashboard.vue
// module id = 959
// module chunks = 1